import { MODULES, type ModuleId } from '@tahi/core';
import { Link } from 'react-router';
import { useUsableModules } from '../../data/hooks';
import type { TileDef } from '../registry';

function WelcomeTile() {
  const usable = useUsableModules();
  const anyOn = (Object.keys(usable) as ModuleId[]).some(
    (id) => usable[id] && id !== 'today' && !MODULES[id].alwaysOn,
  );
  return (
    <div className="flex flex-col gap-2">
      <p className="text-xl font-bold">Welcome to Tahi</p>
      <p className="text-sm text-muted">
        {anyOn ? 'Tap Edit to choose what shows on Today.' : 'Turn on a module to fill Today.'}
      </p>
      <Link
        to="/modules"
        className="inline-flex min-h-11 w-fit items-center rounded-full bg-accent px-5 font-medium text-on-accent"
      >
        Choose modules
      </Link>
    </div>
  );
}

export const welcomeTile: TileDef = {
  type: 'today.welcome',
  moduleId: 'today',
  title: 'Welcome',
  sizes: ['wide'],
  defaultSize: 'wide',
  defaultOnToday: true,
  Component: WelcomeTile,
};
